/*=========================================================================================
  File Name: moduletimeTable.js
  Description: timeTable Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleTimeTableState.js'
import mutations from './moduleTimeTableMutations.js'
import actions from './moduleTimeTableActions.js'
import getters from './moduleTimeTableGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
